import type { Alert } from '@src/features/alerts/types';

export function isAlertFieldEditable(alert: Alert, field: string) {
  return alert.editableFields.includes(field);
}
